import { useState, useEffect } from "react";
import Login from "./componentes/ComponenteLogin/Login";
import Painel from "./componentes/Painel";
import { Box } from "@mui/material";

function App() {
  const [autenticado, setAutenticado] = useState<boolean>(false);
  const [role, setRole] = useState<
    "MASTER" | "PARTNER" | "ANALYST" | undefined
  >(undefined);

  // Função para verificar o estado de login ao carregar a página
  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    const storedRole = sessionStorage.getItem("role");

    // Se ambos os valores existem, o usuário está logado
    if (storedToken && storedRole) {
      setAutenticado(true);
      setRole(storedRole as "MASTER" | "PARTNER" | "ANALYST"); // Garantir que o tipo de role seja seguro
    }
  }, []); // O useEffect roda uma única vez na montagem do componente

  const recebeLogin = async (role: "MASTER" | "PARTNER" | "ANALYST") => {
    setAutenticado(true);
    setRole(role);

    // Aqui você pode também armazenar o token e o role no sessionStorage
    const token = sessionStorage.getItem("token"); // Verifique como você obtem o token após o login
    if (token) {
      sessionStorage.setItem("role", role); // Armazene o role no sessionStorage
    }
  };

  return (
    <Box className="App">
      {autenticado && role ? (
        <Painel role={role} token={sessionStorage.getItem("token") || ""} />
      ) : (
        <Box className="container-display">
          <Login onLogin={recebeLogin} />
        </Box>
      )}
    </Box>
  );
}

export default App;
